module.exports = __webpack_public_path__ + "img/user-profile-picture-placeholder.86f0e134.png";